import { useEffect, useState } from "react";
import axios from "axios";
import { Users } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function VisitorCounter() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    const today = new Date().toISOString().slice(0, 10);
    const flag = `sp_visit_${today}`;
    const already = localStorage.getItem(flag);

    const run = async () => {
      try {
        if (already) {
          const { data } = await axios.get(`${API}/visits/stats`);
          setStats(data);
        } else {
          const { data } = await axios.post(`${API}/visits/track`);
          localStorage.setItem(flag, "1");
          setStats(data);
        }
      } catch {
        /* silent */
      }
    };
    run();
  }, []);

  if (!stats) return null;

  return (
    <div
      data-testid="visitor-counter"
      className="border-t border-white/10 bg-[#030712]"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10 py-6 flex flex-col sm:flex-row items-center justify-center gap-x-8 gap-y-2 text-center">
        <div className="flex items-center gap-2 text-white/50">
          <Users className="h-4 w-4 text-cyan-glass" strokeWidth={1.5} />
          <span className="font-mono text-xs uppercase tracking-[0.15em]">Besucher</span>
        </div>
        <div className="flex items-center gap-6">
          <span className="font-mono text-sm text-white/70">
            Heute: <span className="text-cyan-glass font-medium" data-testid="visitors-today">{stats.today.toLocaleString("de-DE")}</span>
          </span>
          <span className="font-mono text-sm text-white/70">
            Gesamt: <span className="text-white font-medium" data-testid="visitors-total">{stats.total.toLocaleString("de-DE")}</span>
          </span>
        </div>
      </div>
    </div>
  );
}
